import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { SelectItem } from "primeng/api";
import { NotificationTypes } from "src/app/app.enums";
import { Events } from "src/app/models/emailevents.model";
import { EmailEventTypeService } from "src/app/Services/email-event-type.service";
import { NotificationsService } from "src/app/Services/shared/notifications.service";
import { TranslocoService } from "@jsverse/transloco";

@Component({
    selector: 'sms-events-dailog',
    templateUrl: './sms-event-dailog.component.html',
    inputs: ['isAddEmailEventDailogVisible', 'isEditMode', 'emailEventsFormData', 'selectedEmailParameters', 'emailParameters'],
    outputs: ['onCloseEmailEventDailog', 'getEmailEvents'],
    standalone: false
})
export class SMSEventDailogComponent implements OnInit {
    public isEditMode: boolean = false;
    public isAddEmailEventDailogVisible: boolean = false;
    public emailEventsFormData!: Events;
    public emailParameters: SelectItem[] = [];
    public selectedEmailParameters: SelectItem[] = [];
    public onCloseEmailEventDailog = new EventEmitter<boolean>();
    public getEmailEvents = new EventEmitter<void>();

    constructor(
        private ngxSpinnerService: NgxSpinnerService,
        private notificationsService: NotificationsService,
        private emailEventTypeService: EmailEventTypeService,
        private transloco: TranslocoService
    ) { }

    ngOnInit(): void { }

    public onCloseEmailEventsDialog() {
        this.isAddEmailEventDailogVisible = false;
        this.emailEventsFormData = new Events();
        this.selectedEmailParameters = [];
        this.onCloseEmailEventDailog.emit(this.isAddEmailEventDailogVisible);
    }

    public onEventParametersChange($event: any) {
        this.emailEventsFormData.EmailParameterIds = $event.value.map((p: { value: any }) => p.value);
    }

    public onSaveEmailEvents() {
        if (this.isEditMode) {
            console.log('edit', this.emailEventsFormData);
            this.ngxSpinnerService.show();
            this.emailEventTypeService.saveEmailEvents(this.emailEventsFormData).subscribe(
                (response) => {
                    this.ngxSpinnerService.hide();
                    if (response.Success) {
                        this.onCloseEmailEventsDialog();
                        this.notificationsService.showNotification(this.transloco.translate('smsEventDailog.success'), response.ResponseMessage, NotificationTypes.Success);
                        this.getEmailEvents.emit();
                    } else {
                        this.notificationsService.showNotification(this.transloco.translate('smsEventDailog.error'), response.ResponseMessage, NotificationTypes.Error);
                    }
                },
                (error) => {
                    console.error(error);
                    this.ngxSpinnerService.hide();
                }
            );
        } else {
            console.log('add', this.emailEventsFormData);
            this.ngxSpinnerService.show();
            this.emailEventTypeService.saveEmailEvents(this.emailEventsFormData).subscribe(
                (response) => {
                    this.ngxSpinnerService.hide();
                    if (response.Success) {
                        this.onCloseEmailEventsDialog();
                        this.notificationsService.showNotification(this.transloco.translate('smsEventDailog.success'), response.ResponseMessage, NotificationTypes.Success);
                        this.getEmailEvents.emit();
                    } else {
                        this.notificationsService.showNotification(this.transloco.translate('smsEventDailog.error'), response.ResponseMessage, NotificationTypes.Error);
                    }
                },
                (error) => {
                    console.error(error);
                    this.ngxSpinnerService.hide();
                }
            );
        }
    }
}